import { IAppPromotionBannerLinks } from "@faire/web-api/indigofair/data/IAppPromotionBannerLinks";
import { APP_PROMOTION_BANNER_LINKS } from "@faire/web-api/indigofair/settings/APP_PROMOTION_BANNER_LINKS";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingAppPromotionBannerLinks =
  (): IAppPromotionBannerLinks => {
    return getSettingValueWithoutAssignment(APP_PROMOTION_BANNER_LINKS, {
      "app_store_link": "",
      "play_store_link": "",
      "ios_deep_link": "",
      "android_deep_link": "",
    }) as IAppPromotionBannerLinks;
  };
